<div class="lubricant-wrapper" [formGroup]="form">
    <div class="row">
        <div class="col-4">
            <mat-label class="mat-label-general" container="body" placement="right" tooltipClass="custom-tooltip">
                <!-- Lubricants -->
                Calculation Type
            </mat-label>
        </div>
        <div class="col-8">
            <mat-select name="lubricants" [disabled]="disable" class="lubricant-select" [class.spinner]="loading" formControlName="calculationType">
                <mat-option value="0">Standard Flange</mat-option>
                <mat-option value="2">Clamp</mat-option>
            </mat-select>
        </div>
    </div>
</div>
